// Classifies Supabase auth errors so we don't accidentally "log out" users
// on transient network/timeouts during page refresh.
//
// Supabase-js errors commonly include:
// - message: string
// - status: number (e.g. 401)
export const isDefinitelyInvalidAuthSessionError = (error) => {
  if (!error) return false;

  const status = error?.status ?? error?.statusCode ?? error?.status_code;
  const msg = String(error?.message || '').toLowerCase();

  // If the server explicitly says unauthorized, the access token is not valid.
  if (status === 401) return true;

  // Common token/session-invalid messages seen across GoTrue / Supabase.
  if (msg.includes('invalid jwt')) return true;
  if (msg.includes('jwt expired')) return true;
  if (msg.includes('token is expired')) return true;
  if (msg.includes('invalid token')) return true;
  if (msg.includes('refresh token') && (msg.includes('invalid') || msg.includes('not found'))) {
    return true;
  }

  return false;
};

